import keyMirror from 'keymirror';

export default keyMirror({
  AUTH_CUSTOMER_START             : null,
  AUTH_CUSTOMER_SUCCESS           : null,
  AUTH_CUSTOMER_FAILURE           : null,
  DISMISS_COOKIES_START           : null,
  LOAD_DISMISS_COOKIES_START      : null,
  SIGNOUT_CUSTOMER_START          : null,
  SIGNOUT_CUSTOMER_SUCCESS        : null,
  SIGNOUT_CUSTOMER_FAILURE        : null,
  FETCH_CUSTOMER_START            : null,
  FETCH_CUSTOMER_SUCCESS          : null,
  FETCH_CUSTOMER_FAILURE          : null,
  UPDATE_CUSTOMER_START           : null,
  UPDATE_CUSTOMER_SUCCESS         : null,
  UPDATE_CUSTOMER_FAILURE         : null,
  ADD_CUSTOMER_IDENTIFIER_START   : null,
  ADD_CUSTOMER_IDENTIFIER_SUCCESS : null,
  ADD_CUSTOMER_IDENTIFIER_FAILURE : null,
  RESET_CUSTOMER_PASSWORD_START   : null,
  RESET_CUSTOMER_PASSWORD_SUCCESS : null,
  RESET_CUSTOMER_PASSWORD_FAILURE : null
});



// WEBPACK FOOTER //
// banquet/constants/CustomerConstants.js